import { Reducer } from "@reduxjs/toolkit"
import { EstadoRequisicao } from "store/types"
import { PessoasAction } from "./Pessoas.action"
import { PessoasActionTypes, PessoasState } from "./Pessoas.types"
import { concatenateSets } from 'util/collections';

const estadoInicial: PessoasState = {
  timer: undefined,

  pessoas: {
    naFila: new Set<string>(),
    emRequisicao: new Set<string>(),
    carregadas: new Set<string>(),
  },
  cache: {},

  estado: EstadoRequisicao.OCIOSO,
}


export const pessoasReducer: Reducer<PessoasState, PessoasActionTypes> = (state = estadoInicial, action): PessoasState => {
  if (PessoasAction.adicionarNaFila.match(action)) {
    return {
      ...state,
      pessoas: {
        ...state.pessoas,
        naFila: concatenateSets(state.pessoas.naFila, [action.payload]),
      },
    }

  } else if (PessoasAction._carregar.pending.match(action)) {
    const identificadorTimer = state.timer === undefined
      ? action.meta.arg
      : state.timer;

    return {
      ...state,
      timer: identificadorTimer,
      estado: EstadoRequisicao.CARREGANDO,
      pessoas: {
        ...state.pessoas,
        naFila: new Set(),
        emRequisicao: new Set(state.pessoas.naFila),
      },
    }

  } else if (PessoasAction._carregar.fulfilled.match(action)) {
    if (action.payload === undefined) {
      return state;
    }
    const pessoas = action.payload.content;

    const cacheAtualizado = {...state.cache}
    const idsPessoasCarregadas = new Set<string>();
    pessoas.forEach(it => {
      cacheAtualizado[it.idInstitucional] = it
      idsPessoasCarregadas.add(it.idInstitucional);
    });

    return {
      ...state,
      estado: EstadoRequisicao.BEM_SUCEDIDO,
      pessoas: {
        ...state.pessoas,
        emRequisicao: new Set(),
        carregadas: concatenateSets(state.pessoas.emRequisicao, [action.payload]),
      },
      cache: cacheAtualizado
    }
  } else if (PessoasAction.timer.finalizar.match(action)) {
    const isTimerRedundanteDesnecessario = action.payload !== state.timer;

    if (isTimerRedundanteDesnecessario) {
      console.warn("Timer desnecessário disparou hook");
      return state;
    }

    return {
      ...state,
      timer: undefined
    }
  }

  return state
}
